import React, { useState } from "react";
import "./AdminLogin.css";
import Verification from "./Verification";
import VerifyOTP from "./VerifyOTP";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import PopupMessage from "../PopupMessage/PopupMessage";
import { adminPasswordLogin } from "../Apis/AdminApis";
import logo1 from "../images/LargeTile.scale-150.png";
import logo2 from "../images/LargeTile.scale-150.png";
import logo3 from "../images/LargeTile.scale-150.png";
import logo4 from "../images/LargeTile.scale-150.png";
import logo5 from "../images/LargeTile.scale-150.png";
import logo6 from "../images/LargeTile.scale-150.png";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [step, setStep] = useState("login");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      email: email,
      password: password,
    };

  const response = await adminPasswordLogin(payload);

console.log("Login Response:", response);
console.log("Logo URL:", response.logo_url);

setLoading(false);
    if (response.error || !response.choose_otp_send_type) {
      setPopupMessage(response.error || "Login failed");
      setPopupType("error");
      setPopupOpen(true);
      return;
    }
    setPopupMessage(response.message);
    setPopupType("success");
    setPopupOpen(true);
    sessionStorage.setItem("adminEmail", response.email);
    sessionStorage.setItem("adminName", response.name);
    sessionStorage.setItem("adminRole", response.role);
    localStorage.setItem("admin_name", response.name || "");
    localStorage.setItem("admin_role", response.role || "");

    
    setTimeout(() => {
      setStep("verification");
    }, 500);
  };

  const handleForgotPassword = () => {
    setStep("forgot");
  };

  const handleBackToLogin = () => {
    setStep("login");
    setForgotEmail("");
  };

  return (
    <div className="login-wrapper">
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />
      <div className="logo-background">
        <img src={logo1} className="small-logo logo1" alt="" />
        <img src={logo2} className="small-logo logo2" alt="" />
        <img src={logo3} className="small-logo logo3" alt="" />
        <img src={logo4} className="small-logo logo4" alt="" />
        <img src={logo5} className="small-logo logo5" alt="" />
        <img src={logo6} className="small-logo logo6" alt="" />
      </div>

      {step === "login" && (
        <div className="login-card">
          <h2>Login to Account</h2>
          <p>Please enter your email and password to continue</p>

          <label>Email address:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <div className="password-row">
            <label>Password:</label>
            <span className="forgot" onClick={handleForgotPassword}>
              Forgot Password?
            </span>
          </div>

          <div className="password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="password-input"
            />
            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword(!showPassword)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setShowPassword(!showPassword);
                  e.preventDefault();
                }
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button onClick={handleSubmit} disabled={loading}>
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </div>
      )}

      {step === "forgot" && (
        <ForgotPassword
          onBack={handleBackToLogin}
          onSuccess={(email) => {
            setForgotEmail(email);
            setStep("reset");
          }}
          setPopupMessage={setPopupMessage}
          setPopupType={setPopupType}
          setPopupOpen={setPopupOpen}
        />
      )}

    {step === "reset" && (
  <ResetPassword
    identifier={forgotEmail} 
    onBack={() => setStep("forgot")}
    onSuccess={() => {
      setStep("login");
      setPopupMessage("Password reset successfully! Please login with your new password.");
      setPopupType("success");
      setPopupOpen(true);
    }}
    setPopupMessage={setPopupMessage}
    setPopupType={setPopupType}
    setPopupOpen={setPopupOpen}
  />
)}

      {step === "verification" && (
        <Verification
          onClose={() => setStep("login")}
          onSelectMethod={() => setStep("otp")}
        />
      )}

      {step === "otp" && (
        <VerifyOTP onBack={() => setStep("verification")} />
      )}
    </div>
  );
};

export default AdminLogin;